<template>
    <div>
        <v-menu v-model="isShowIssueBulkInvoicesMenu" :close-on-content-click="false">
            <template v-slot:activator="{props}">
                <v-btn
                    :loading="isLoadingIssueBulkInvoices"
                    variant="text"
                    :color="'primary'"
                    size="x-small"
                    v-bind="props"
                    @click="isShowIssueBulkInvoicesMenu = true"
                >
                    {{ label }}
                </v-btn>
            </template>
            <v-card>
                <v-card-title v-if="label">{{ label }}</v-card-title>
                <v-card-text>
                    <v-radio-group v-model="invoiceType" density="compact" hide-details class="mt-0">
                        <v-radio
                            v-for="radioItem in invoiceTypes"
                            :key="radioItem.value"
                            :label="radioItem.title"
                            :value="radioItem.value"
                        />
                    </v-radio-group>
                    <v-divider class="my-2" />
                    <v-radio-group v-model="reportFileType" inline density="compact" hide-details class="mt-0">
                        <v-radio
                            v-for="radioItem in formats"
                            :key="radioItem.fileType"
                            class="me-1"
                            :label="radioItem.fileType"
                            :value="radioItem"
                        />
                    </v-radio-group>
                </v-card-text>
                <v-card-actions class="px-4">
                    <v-btn
                        class="full-width"
                        :color="'primary'"
                        variant="flat"
                        :loading="isLoadingIssueBulkInvoices"
                        :disabled="radioGroupIssueBulkInvoicesSupplier === '' || isLoadingIssueBulkInvoices"
                        @click="issueBulkInvoicesSupplier"
                    >
                        {{ $t('confirm') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-menu>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator'
    import {downloadData} from '~/utils/helpers'

    @Component
    export class IssueBulkInvoicesMenu extends Vue {
        @Prop({required: true}) filterKey
        @Prop() label
        @Prop() selectedObjectIds

        isShowIssueBulkInvoicesMenu = false
        isLoadingIssueBulkInvoices = false
        invoiceType = 'SUPPLIER'
        reportFileType = null

        @Watch('isShowIssueBulkInvoicesMenu')
        onDialogChange() {
            this.reportFileType = this.formats[0]
        }

        async issueBulkInvoicesSupplier() {
            this.isLoadingIssueBulkInvoices = true

            try {
                const rs = await this.$api.issueBulkInvoices.post({
                    orderIds: this.selectedObjectIds,
                    invoiceType: this.invoiceType,
                })
                await this.printRevise(rs.invoices.map(e => e.invoiceId))

                this.isShowIssueBulkInvoicesMenu = false
                this.$toast.success(this.$t('success_message.saved_successfully'))
            } catch (e) {
                this.$toast.error(e?.errors?.[0]?.message || this.$t('error_message.something_went_wrong'))
            } finally {
                this.isLoadingIssueBulkInvoices = false
            }
        }

        async printRevise(invoiceIdArray) {
            try {
                const data = await this.$api.printRevise.get({
                    invoiceId: invoiceIdArray,
                    reportFileType: this.reportFileType.fileType,
                })
                downloadData(data, `revise-act.${this.reportFileType.extension}`)
            } catch (error) {
                this.$toast.error(error?.errors?.[0]?.message || this.$t('error_message.save_error'))
            }
        }

        get invoiceTypes() {
            return [
                {title: this.$t('invoices.supplier'), value: 'SUPPLIER'},
                {title: this.$t('invoices.client'), value: 'CUSTOMER'},
            ]
        }

        get formats() {
            return [
                {
                    fileType: 'XLSX',
                    icon: 'mdi-file-excel',
                    extension: 'xlsx',
                },
                {
                    fileType: 'PDF',
                    icon: 'mdi-file-pdf',
                    extension: 'pdf',
                },
            ]
        }
    }

    export default IssueBulkInvoicesMenu
</script>
